import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import Icon from 'components/shared/Icon/Icon'
import PropTypes from 'prop-types'
import React from 'react'

import './AnchorLink.scss'

const AnchorLink = ({
  title,
  text,
  href,
  image: { src, alt },
  gtm: { category, label } = {},
}) => {
  const sendDataToGTM = useGTMDispatch()
  const handleClick = () => sendDataToGTM({ category: category, label: label })

  return (
    <div className="anchor-link__container">
      <a className="anchor-link" href={href} onClick={handleClick}>
        <div className="anchor-link__details">
          <img src={src} alt={alt} />
          <h4>{title}</h4>
          <p>{text}</p>
        </div>
        <Icon className="anchor-link__icon" type="arrow-down" />
      </a>
    </div>
  )
}

AnchorLink.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  href: PropTypes.string,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  gtm: PropTypes.object,
}

export default AnchorLink
